<div class="container mt-4">
  <div class="card mb-4 shadow-sm">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h4 class="mb-0">Rôles utilisateur</h4>

      <button class="btn btn-sm btn-outline-primary"
        (click)="toggleEditRoles()">
        {{ editRoles ? 'Terminer' : 'Modifier' }}
      </button>
    </div>

    <div class="card-body">

      <!-- Aucun rôle -->
      @if (userRoles.length === 0) {
        <div class="text-muted">
          Aucun rôle attribué
        </div>
      }

      <!-- Liste rôles -->
      <div class="role-list">
        @for (role of userRoles; track role) {
          <span
            class="badge text-bg-info role-badge">
            {{ role }}
            @if (editRoles) {
              <button
                class="btn btn-xs btn-danger ms-1"
                (click)="removeRole(role)"
                [disabled]="loadingRole === role"
                title="Retirer ce rôle">
                @if (loadingRole === role) {
                  <span
                  class="spinner-border spinner-border-sm"></span>
                }
                @if (loadingRole !== role) {
                  <span>&times;</span>
                }
              </button>
            }
          </span>
        }
      </div>

      <!-- Ajouter rôle -->
      @if (editRoles) {
        <div class="mt-3">
          <label class="mb-2">Ajouter un rôle :</label>
          <div class="add-role-container">
            @for (role of availableRoles; track role) {
              <button
                class="btn btn-sm btn-outline-success"
                (click)="addRole(role)"
                [disabled]="loadingRole === role">
                @if (loadingRole === role) {
                  <span
                  class="spinner-border spinner-border-sm"></span>
                }
                @if (loadingRole !== role) {
                  <span>
                    + {{ role }}
                  </span>
                }
              </button>
            }
          </div>
        </div>
      }

    </div>
  </div>
</div>
